import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open() {
    const modal = document.getElementById("new-album-modal")
    if (modal) {
      modal.classList.remove("hidden")
      document.body.classList.add("overflow-hidden")
    }
  }

  close() {
    const modal = document.getElementById("new-album-modal")
    if (modal) {
      modal.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}